import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Meta } from './types';
import { metaReducerPath } from './const';

export * from './const';
export * from './selectors';
export * from './types';

const initialState: Meta = {
  userAgent: undefined,
};

export const metaSlice = createSlice({
  name: `@@app/${metaReducerPath}`,
  initialState,
  reducers: {
    reset() {
      return { ...initialState };
    },
    setUserAgent(state, action: PayloadAction<Meta['userAgent']>) {
      state.userAgent = action.payload;
    },
  },
});
